var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card"
  }, [_c("img", {
    attrs: {
      src: _vm.icon,
      alt: ""
    }
  }), _c("p", [_vm._v(_vm._s(_vm.desc1))]), _c("p", [_vm._v(_vm._s(_vm.desc2))])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };